<template lang="pug">
v-app
  v-dialog(v-model="drawer", width="500")
    v-card.pa-4
      InlineLayout
        ParcellesSelector.mr-2(
          :items="selectItems",
          v-model="currentParcelleId",
          v-if="selectItems.length > 0"
        )
        template(v-else)
          .pitch.ml-2
            h1 MAPARCEL™
            span Connecter le champ au labo
          v-spacer
        v-btn(icon, @click="toggleLogin", v-if="!isAdmin")
          v-icon mdi-lock
        v-menu(bottom, left, v-if="isAdmin")
          template(v-slot:activator="{ on, attrs }")
            v-btn(icon, v-bind="attrs", v-on="on")
              v-icon mdi-dots-vertical

          v-list
            v-list-item(@click="newParcelle", v-if="isAdmin") Créer une nouvelle parcelle
            v-list-item.login(@click="toggleLogin") Se deconnecter

      ParcelleInfos(:infos="currentParcelleInfo", v-if="drawer")
      .description.pa-3.mt-2(
        v-if="drawer && currentParcelleInfo && currentParcelleInfo.description"
      )
        h3 Infos
        pre {{ currentParcelleInfo.description }}

      .actions.mt-2(v-if="isAdmin && currentParcelleId != null")
        v-btn.specialBtn(@click="editParcelle") 
          v-icon mdi-vector-polygon
        ParcelleEditor(
          :parcelles="parcelles",
          :currentParcelleId="currentParcelleId",
          @update="updateParcelleInfo"
        )
        v-btn.specialBtn(@click="shareParcelle") 
          v-icon mdi-content-copy
        v-btn.specialBtn(@click="deleteParcelle") 
          v-icon mdi-delete

      v-btn.mt-2(
        v-if="currentParcelleId != null",
        @click="newPrelevement",
        block,
        color="primary"
      ) Voir la parcelle
  Map(
    :parcelleId="currentParcelleId",
    :drawLoaded="parcelle",
    @update="updateParcelle",
    @mode="changeMode",
    :allowEditing="isAdmin",
    :editDrawing="editDrawing"
  )
  Logo(@click="drawer = true", :fixed="true")
</template>

<script>
import _ from "lodash";
import Map from "./components/Map";
import ParcelleEditor from "./components/ParcelleEditor";
import InlineLayout from "./components/Layouts/InlineLayout";
import Logo from "./components/Logo";
import ParcelleInfos from "./components/ParcelleInfos";
import ParcellesSelector from "./components/ParcellesSelector";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  addDoc,
  doc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBohbLLMhN32NXsRdJG5O8KWVNdFSKT9z4",
  authDomain: "iage-a0aa9.firebaseapp.com",
  projectId: "iage-a0aa9",
  storageBucket: "iage-a0aa9.appspot.com",
  messagingSenderId: "1092143605228",
  appId: "1:1092143605228:web:5fd1274ed2ec63e8648cc9",
  measurementId: "G-W68MT5YPD5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default {
  name: "App",
  components: {
    Map,
    ParcelleEditor,
    ParcellesSelector,
    ParcelleInfos,
    InlineLayout,
    Logo,
  },
  data: () => ({
    drawer: true,
    //parcelle: null,
    parcelles: null,
    currentParcelleId: null,
    isEditing: false,
    isAdmin: false,
    editDrawing: false,
  }),
  mounted: async function () {
    const urlParam1 = window.location.pathname.slice(1);
    if (urlParam1) {
      const docRef = doc(db, "parcelles", urlParam1);
      const parcelleFromUrl = await getDoc(docRef);
      if (parcelleFromUrl.exists()) {
        this.parcelles = {};
        this.parcelles[urlParam1] = {
          datas: JSON.parse(parcelleFromUrl.data().datas),
          infos: JSON.parse(parcelleFromUrl.data().infos),
        };
        this.currentParcelleId = urlParam1;
      } else {
        console.log("No such document!");
      }
    }
    //this.appSignIn("gauzila@gmail.com", "hollywood");
  },
  computed: {
    currentParcelleInfo() {
      return _.get(this.parcelles, this.currentParcelleId + ".infos");
    },
    url() {
      return (
        window.location.hostname +
        (this.currentParcelleId ? "/" + this.currentParcelleId : "")
      );
    },
    selectItems() {
      const selectItems = _.map(this.parcelles, (parcelle, key) => {
        return { id: key, title: _.get(parcelle, "infos.title", key) };
      });
      return selectItems;
    },
    parcelle() {
      return _.get(this.parcelles, this.currentParcelleId + ".datas");
    },
  },
  methods: {
    getParcelleToSave(options) {
      const datasBrut = _.get(options, "datas", this.parcelle);
      const infosBrut = _.get(options, "infos", this.currentParcelleInfo);
      const parcelleToSave = {
        datas: datasBrut ? JSON.stringify(datasBrut) : "",
        infos: infosBrut ? JSON.stringify(infosBrut) : "",
      };
      return parcelleToSave;
    },
    newPrelevement() {
      this.editDrawing = false;
      this.drawer = false;
    },
    editParcelle() {
      this.editDrawing = true;
      this.drawer = false;
    },
    appSignOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.isAdmin = false;
          this.parcelles = null;
          this.currentParcelleId = null;
        })
        .catch((error) => {
          // An error happened.
        });
    },
    appSignIn(email, password) {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in
          this.isAdmin = true;
          this.loadParcelles();
        })
        .catch((error) => {
          //const errorCode = error.code;
          //const errorMessage = error.message;
        });
    },
    toggleLogin() {
      if (this.isAdmin) {
        this.appSignOut();
      } else {
        this.appSignIn("iage@iage.com", prompt("Mot de passe", ""));
      }
    },
    loadParcelles: async function () {
      const test = await getDocs(collection(db, "parcelles"));
      this.parcelles = {};
      test.forEach((doc) => {
        this.parcelles[doc.id] = {};
        if (doc.data().datas) {
          this.parcelles[doc.id].datas = JSON.parse(doc.data().datas);
        }
        if (doc.data().infos) {
          this.parcelles[doc.id].infos = JSON.parse(doc.data().infos);
        }
      });
    },
    updateParcelle(datas) {
      this.saveParcelle(this.getParcelleToSave({ datas }));
    },
    updateParcelleInfo(infos) {
      this.saveParcelle(this.getParcelleToSave({ infos }));
    },
    newParcelle: async function () {
      const newParcelle = await addDoc(collection(db, "parcelles"), {
        datas: null,
      });
      this.parcelles[newParcelle.id] = { datas: {} };
      this.currentParcelleId = newParcelle.id;
      this.loadParcelles();
    },
    deleteParcelle: async function () {
      if (
        window.confirm(
          "Voulez vous vraiment supprimer la parcelle definitivement ?"
        )
      ) {
        await deleteDoc(doc(db, "parcelles", this.currentParcelleId));
        this.parcelle = null;
        this.currentParcelleId = null;
        this.currentParcelleInfo = null;
        this.loadParcelles();
      }
    },
    shareParcelle() {
      navigator.clipboard.writeText(
        window.location.protocol +
          "//" +
          window.location.host +
          "/" +
          this.currentParcelleId
      );
    },
    changeMode(mode) {
      this.isEditing = mode;
      this.drawer = false;
      if (!this.isEditing) this.editDrawing = false;
    },
    saveParcelle: async function (options) {
      await setDoc(doc(db, "parcelles", this.currentParcelleId), options);
      this.loadParcelles();
    },
  },
  watch: {
    currentParcelleId() {
      //window.history.pushState({}, "", this.currentParcelleId);
    },
  },
};
</script>

<style lang="stylus">
@import url('https://db.onlinewebfonts.com/c/f83531ae85a3fcd9345c4267e28833ee?family=DIN+Next+Rounded+LT+Pro+Medium');

bodyFontColor = #13286b;

body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'DIN Next Rounded LT Pro Medium', sans-serif;
  color: bodyFontColor;
  line-height: 1.2;
  font-size: 17px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.drawer {
  padding-top: 90px;
}

html, body {
  overflow-y: auto;
}

.pitch {
  h1 {
    color: #13286b;
  }

  span {
    color: #00b4e2;
  }
}

.description {
  background-color: #eee;
  border-left: #00b4e2 5px solid;

  h3 {
    color: #00b4e2;
  }

  pre {
    text-wrap: wrap;
  }
}

.actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.specialBtn {
  display: flex;
  flex: 1;
  flex-direction: column;
}
</style>
